import { useQuery } from 'react-query'
import request from '../request'

export const useGetReportsByAgencyId = ({
  agency_id,
  prefix = undefined,
  enabled = true,
}: {
  agency_id: number
  prefix?: string | undefined
  enabled?: boolean
}) => {
  return useQuery(
    ['agencies', agency_id, 'reports', prefix],
    ({ signal }) =>
      request<{
        data: Array<{
          path: string
          name: string | undefined
          raw_path: string
          next_prefix?: string | undefined
          type: 'file' | 'folder'
          url: string
        }>
        path_type: 'file' | 'folder'
      }>({
        url: `/agencies/${agency_id}/reports`,
        signal,
        method: 'GET',
        params: {
          prefix,
        },
      }),
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  )
}
